import { useEffect, useState } from 'react'
import { throttle } from 'lodash'
import { theme } from './theme'

export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState<boolean>()

  const handleIsDesktop = throttle(() => {
    setIsDesktop(window.innerWidth >= theme.breakpoints.s)
  }, 1000)

  useEffect(() => {
    handleIsDesktop()
    window.addEventListener('resize', handleIsDesktop)

    return () => {
      window.removeEventListener('resize', handleIsDesktop)
    }
  }, [])

  return { isDesktop }
}
